// Regex for prohibited special characters
const SPECIAL_CHARS_REGEX = /[/*&^%$#@><+=\-_]/;
const SSI_SPECIAL_CHARS_REGEX = /[^a-zA-Z0-9-]/;

/**
 * Validates that the value does NOT contain defined special characters.
 * @param {string} value - The value to validate.
 * @returns {true|string} - true if valid, or an error message if not.
 */
export function validateNoSpecialChars(value) {
  if (typeof value !== 'string') return true;
  if (SPECIAL_CHARS_REGEX.test(value)) {
    return 'Please remove any special character from this field to continue with your application (/*&^%$#@><+=-_)';
  }
  return true;
}

/**
 * Validates that the value does NOT contain defined special characters.
 * @param {string} value - The value to validate.
 * @returns {true|string} - true if valid, or an error message if not.
 */
export function validateNoSpecialCharsForSSI(value) {
  if (typeof value !== 'string') return true;
  if (SSI_SPECIAL_CHARS_REGEX.test(value)) {
    return 'Please use only letters, numbers, and/or dashes (-).';
  }
  return true;
}
